import { DispensariesPage } from 'src/dispensaries';
import { MainLayout } from 'components/layouts/main-layout';

DispensariesPage.layout = MainLayout;

export default DispensariesPage;
